import { Component, Input } from "@angular/core";
import { AppConsts } from "@shared/AppConsts";
import { AttachmentViewDto } from "@shared/service-proxies/service-proxies";

@Component({
  selector: "app-attachments",
  templateUrl: "./app-attachments.component.html",
  styleUrls: ["./app-attachments.component.scss"],
})
export class AppAttachmentsComponent {
  @Input() attachments: AttachmentViewDto[] = [];
  filePath = `${AppConsts.s3Url}/`;
  getIconClass(extension: string): string {
    // Map file extensions to Font Awesome icons or provide a default icon
    const extensionIcons: { [key: string]: string } = {
      pdf: "fas fa-file-pdf",
      doc: "fas fa-file-word",
      xls: "fas fa-file-excel",
      jpg: "fas fa-file-image",
      png: "fas fa-file-image",
      default: "fas fa-file",
    };
    return extensionIcons[extension] || extensionIcons.default;
  }

  getFileExtension(fileName: string): string {
    const parts = fileName.split(".");
    return parts[parts.length - 1].toLowerCase();
  }

  viewAttachment(attachment: AttachmentViewDto): void {
    const extension = this.getFileExtension(attachment.attachmentName);

    let filePath = `${AppConsts.s3Url}/`;
    if (attachment.path) filePath += attachment.path + "/";

    filePath += attachment.attachmentName;
    console.log(filePath);

    if (extension === "jpg" || extension === "png" || extension === "jpeg") {
      // If it's an image, open it in a new window or tab.
      window.open(filePath, "_blank");
    } else {
      // For other file types, initiate a download.
      const downloadLink = document.createElement("a");
      downloadLink.href = filePath;
      downloadLink.target = "_blank";
      downloadLink.download = attachment.attachmentName;
      downloadLink.click();
    }
  }
}
